// extracted by mini-css-extract-plugin
module.exports = {"info__energyCostParagraph":"InfoPanel_info__energyCostParagraph__2rSVr","info__table":"InfoPanel_info__table__0gFj8","info":"InfoPanel_info__42NDG"};